"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Envelope = function Envelope(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 26 20"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-997.000000, -166.000000)",
    fillRule: "nonzero",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(997.000000, 166.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.8259747,0 L3.17938983,0 C1.42561473,0 0,1.44100054 0,3.2137031 L0,16.7862969 C0,18.5589995 1.42561473,20 3.17938983,20 L22.820595,20 C24.5743701,20 25.9999848,18.5589995 25.9999848,16.7862969 L25.9999848,3.21914084 C26.0053645,1.44643828 24.5797498,0 22.8259747,0 Z M24.5528514,16.7862969 C24.5528514,17.7487765 23.7781777,18.5318108 22.8259747,18.5318108 L3.17938983,18.5318108 C2.22718678,18.5318108 1.45251312,17.7487765 1.45251312,16.7862969 L1.45251312,3.21914084 C1.45251312,2.25666123 2.22718678,1.47362697 3.17938983,1.47362697 L22.820595,1.47362697 C23.772798,1.47362697 24.5474717,2.25666123 24.5474717,3.21914084 L24.5474717,16.7862969 L24.5528514,16.7862969 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.3918352,9.83261036 L22.7477076,4.24626255 C23.0434547,3.98275558 23.0703408,3.53479373 22.8014798,3.23966592 C22.5326189,2.94980825 22.0755553,2.92345755 21.7744311,3.18696452 L13.0095646,10.8971785 L11.2996091,9.40045893 C11.2942318,9.39518879 11.2888546,9.38991865 11.2888546,9.38464851 C11.2512141,9.34775753 11.2135736,9.31613669 11.1705558,9.28451586 L4.21243484,3.18169438 C3.91131059,2.91818741 3.454247,2.94453811 3.18538607,3.23966592 C2.91652514,3.53479373 2.94341123,3.98275558 3.24453548,4.24626255 L9.67568902,9.88004161 L3.27142157,15.7562471 C2.98105176,16.0250242 2.9649201,16.4729861 3.23915826,16.7628437 C3.38434316,16.9104076 3.57792303,16.9894597 3.77150291,16.9894597 C3.94895112,16.9894597 4.12639934,16.926218 4.26620703,16.7997347 L10.7672644,10.839207 L12.5309921,12.3833578 C12.6707998,12.5045711 12.8428708,12.5625426 13.0149418,12.5625426 C13.1870128,12.5625426 13.364461,12.4993009 13.4988915,12.3780877 L15.3110142,10.7865056 L21.7744311,16.8050048 C21.9142387,16.9367583 22.0970642,17 22.2745124,17 C22.4680923,17 22.6562949,16.926218 22.8014798,16.7786541 C23.075718,16.4940666 23.0649635,16.0408346 22.7745937,15.7720575 L16.3918352,9.83261036 Z"
  })))));
};
/* eslint-enable */
var _default = Envelope;
exports["default"] = _default;